const path = require('path')
const files = require.context('@/router/modules', true, /\.js$/)
let routes = []

files.keys().forEach(key => {
  const name = path.basename(key, '.js')

  if (name !== 'index') {
    const module = files(key).default || []

    routes = [
      ...routes,
      ...module
    ]
  }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js